<template>
  <div :class="wrapperClass">
    <UiLabel v-if="label">{{ label }}</UiLabel>
    <SfSelect
      v-bind="$attrs"
      :id="`${id}-select`"
      :data-testid="`${id}-select`"
      :wrapper-class-name="selectWrapperClass"
      class="!pr-14 text-neutral-900 disabled:text-disabled-900"
      :placeholder="label"
      :size="size"
      :invalid="invalid"
      :disabled="disabled"
      :wrapper-class="[
        'border-neutral-300 hover:border-primary-800 focus:border-primary-800',
        {
          '!border-disabled-300 !bg-disabled-100 hover:!ring-disabled-300 focus:!ring-disabled-300': disabled,
        },
      ]"
    >
      <template #chevron>
        <IconChevron
          :class="[
            `pointer-events-none absolute right-4 top-2 size-6 fill-neutral-500 ${iconClass}`,
            { '!fill-disabled-500': disabled },
          ]"
        />
      </template>
      <slot />
    </SfSelect>
    <UiErrorMessage v-if="invalid && errorMessage" :message="errorMessage" />
    <UiHelpText v-if="helpText" :text="helpText" />
  </div>
</template>

<script setup lang="ts">
import type { SelectProps } from '~/components/ui/Select/types';

withDefaults(defineProps<SelectProps>(), {
  size: 'base',
});

defineOptions({
  inheritAttrs: false,
});
</script>
